"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendPollViewEvent = void 0;
var _1 = require(".");
/**
 * Sends an event poll has been viewed
 * Event name: "webd::::poll_view"
 * @param poll_id the id of the poll the user is viewing
 * @param namespace which content type the poll is placed on (eg: story, part, comment, etc)
 * @param resource_id the id of the content that the poll is placed on (eg: story_id, part_id, comment_id)
 * @param interacted the state of the poll that the user is viewing
 */
var sendPollViewEvent = function (poll_id, namespace, resource_id, interacted) {
    (0, _1.sendEvent)(null, null, null, "poll_view", {
        poll_id: poll_id,
        namespace: namespace,
        resource_id: resource_id,
        interacted: interacted,
    });
};
exports.sendPollViewEvent = sendPollViewEvent;
